module.exports = __webpack_public_path__ + "media/images/icons/outlined/link-a9c3f01e76a39da94ba895a3fc0dfcd1.svg";